import merge from 'lodash.merge';
import { client as analyze } from './Analyze'; // používá se

const resolvers = merge(analyze);
export default resolvers;
